import React from "react";

const PartnerCarousel = () => {
  const partners = [
    {
      id: 1,
      name: "Partner 1",
      logo: "/ataya.png",
    },
    {
      id: 2,
      name: "Partner 2",
      logo: "bti.png",
    },
    {
      id: 3,
      name: "Partner 3",
      logo: "cablefree.png",
    },
    {
      id: 4,
      name: "Partner 4",
      logo: "netopsight.png",
    },
    {
      id: 5,
      name: "Partner 5",
      logo: "open5g.png",
    },
    {
      id: 6,
      name: "Partner 6",
      logo: "opticoms.png",
    },
    {
      id: 7,
      name: "Partner 7",
      logo: "xintegra.png",
    },
  ];

  // Partner logosunu iki kez göstererek sonsuz döngü yaratıyoruz
  const duplicatedPartners = [
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
    ...partners,
  ];

  return (
    <div className="overflow-hidden partners-band-parent">
      <div className="flex animate-marquee whitespace-nowrap partners-band ">
        {duplicatedPartners.map((partner, index) => (
          <div key={index} className="flex-none mx-4">
            <img
              src={partner.logo}
              alt={partner.name}
              className="w-24 h-auto"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerCarousel;
